import { Title } from 'react-head'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { CmsEditorProvider } from '../providers/CmsEditor.provider'
import CmsEditorWrapper from '../components/CmsEditor/CmsEditorWrapper'
import { useMemo } from 'react'

const CmsEditorRoute = () => {
  const { tr } = useTr()

  const title = useMemo(() => {
    return tr(TrKey.editorRouteTitle) + ' | Atlascloud'
  }, [tr])

  return (
    <>
      <Title>{title}</Title>
      <CmsEditorProvider>
        <CmsEditorWrapper />
      </CmsEditorProvider>
    </>
  )
}

export default CmsEditorRoute
